import { jwtDecode } from 'jwt-decode';
import api from '../services/api';

const getLocalRefreshToken = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? user.refresh : null;
};

const getLocalAccessToken = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? user.access : null;
};

const updateLocalAccessToken = (token) => {
    let user = JSON.parse(localStorage.getItem('user'));
    user.access = token;
    localStorage.setItem('user', JSON.stringify(user));
};

const getUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

const setUser = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
};

const removeUser = () => {
    localStorage.removeItem('user');
};

const isValidToken = (token) => {
    if (!token) {
        return false;
    }
    try {
        const decoded = jwtDecode(token);
        return Date.now() < decoded.exp * 1000; // Check if the current time is before the token expiration
    } catch (error) {
        return false;
    }
};

const refreshAccessToken = async (refreshToken) => {
    if (!refreshToken) {
        console.error('refreshAccessToken: No refresh token available');
        throw new Error('No refresh token available');
    }

    console.log('refreshAccessToken: Attempting to refresh token...');
    try {
        const response = await api.post('/refresh-token/', { refresh: refreshToken });
        console.log('refreshAccessToken: Refresh response received');
        
        if (!response.data || !response.data.access) {
            console.error('refreshAccessToken: Invalid response format', response.data);
            throw new Error('Invalid refresh token response');
        }
        
        const newAccessToken = response.data.access;
        console.log('refreshAccessToken: New token received, updating localStorage');
        updateLocalAccessToken(newAccessToken);
        console.log('refreshAccessToken: Token updated successfully');
        return newAccessToken;
    } catch (error) {
        console.error('refreshAccessToken: Failed to refresh access token:', error);
        console.error('refreshAccessToken: Error response:', error.response?.data);
        console.error('refreshAccessToken: Error status:', error.response?.status);
        throw error;
    }
};

const TokenService = {
    getLocalRefreshToken,
    getLocalAccessToken,
    updateLocalAccessToken,
    getUser,
    setUser,
    removeUser,
    isValidToken,
    refreshAccessToken,
};

export default TokenService;
